import { render, staticRenderFns } from "./AddInventoryTransferForm.vue?vue&type=template&id=b3f13336&scoped=true"
import script from "./AddInventoryTransferForm.vue?vue&type=script&lang=js"
export * from "./AddInventoryTransferForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f13336",
  null
  
)

export default component.exports